import { AccountsService } from 'base/accounts_service';
import { AccountStore } from 'base/account_store';
import { AnalyticsService } from 'base/analytics';
import { UnreachableError } from 'base/helpers';
import { useDocumentTitle } from 'base/ui/document_title';
import { authRouteToUrl } from 'blocks/auth/routes';
import { dashboardRouteToUrl } from 'blocks/dashboard/routes';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { GoogleCallback } from './google_callback';
import styles from './page.css';
import { CallbackRoute } from './routes';

export const CallbackPages = observer(function _CallbackPages({
  route: rawRoute,
  accountsService,
  accountStore,
  analytics,
}: {
  route: CallbackRoute;
  accountsService: AccountsService;
  accountStore: AccountStore;
  analytics: AnalyticsService;
}) {
  const route = rawRoute;
  let content;
  let title;

  if (route.path === 'callbacks/google_callback') {
    title = 'Google Callback';
    content = (
      <GoogleCallback
        accountsService={accountsService}
        onLogin={() => {
          analytics.track({
            event: 'signup_flow:with_google_sign_in_success',
          });
          window.location.href = dashboardRouteToUrl({ path: 'dashboard' });
        }}
        onSignup={() => {
          analytics.track({
            event: 'signup_flow:with_google_sign_up_success',
          });
          window.location.href = authRouteToUrl({
            path: 'signup/choose-plan',
            context: {},
          });
        }}
        accountStore={accountStore}
      />
    );
  } else {
    throw new UnreachableError(route as never);
  }

  useDocumentTitle(`${title} - Relume`);

  return <div className={styles.callbackContainer}>{content}</div>;
});
